module.exports = __webpack_public_path__ + "img/3.fa73ddd8.jpg";